import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import {
  parseOnboardingSlideKey,
  resolveRegistrationStep,
  type OnboardingSlideKey,
} from './registration-flow';
import {
  resolveNextImplementedRegistrationPath,
  resolveNextRegistrationPath,
  resolvePreviousImplementedRegistrationPath,
} from './registration-navigation';

export type RegistrationRouteState = ReturnType<
  typeof resolveRegistrationStep
> & {
  nextImplementedPath: string | null;
  nextPath: string | null;
  onboardingSlide: OnboardingSlideKey;
  previousImplementedPath: string | null;
};

export function resolveRegistrationRouteState(
  pathname: string,
  search: string,
): RegistrationRouteState {
  const searchParams = new URLSearchParams(search);
  const onboardingSlide = parseOnboardingSlideKey(searchParams.get('slide'));
  const stepState = resolveRegistrationStep(pathname, search);
  const stepId = stepState.currentStep.id;

  return {
    ...stepState,
    nextImplementedPath: resolveNextImplementedRegistrationPath(stepId),
    nextPath: resolveNextRegistrationPath(stepId),
    onboardingSlide,
    previousImplementedPath: resolvePreviousImplementedRegistrationPath(stepId),
  };
}

export function useRegistrationRouteState(): RegistrationRouteState {
  const location = useLocation();

  return useMemo(
    () => resolveRegistrationRouteState(location.pathname, location.search),
    [location.pathname, location.search],
  );
}
